import { render, staticRenderFns } from "./ShowSwot.vue?vue&type=template&id=1a235fd6"
import script from "./ShowSwot.vue?vue&type=script&lang=js"
export * from "./ShowSwot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports